import { useId, useState, useEffect } from 'react';
import BackButton from './BackButton.js';
import './index.css';

function Juugs() {
    const [email, setEmail] = useState('');
    const [juugs, setJuugs] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    const [juugToDelete, setJuugToDelete] = useState(null);
    const emailInputId = useId();

    // SHOW JUUGS
    useEffect(() => {
        if (!email) return;

        const fetchData = async () => {
            try {
                const res = await fetch(
                    `/juugs?email=${encodeURIComponent(email)}`
                );

                if (!res.ok) {
                    console.log('JUUGS NOT SHOWIN');
                    return;
                }

                const data = await res.json();
                setJuugs(data.juug ?? []);
                setHasSearched(true);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, [email]);

    // DELETE JUUG
    async function deleteJuugs(name) {
        try {
            const res = await fetch(
                `/delete?email=${encodeURIComponent(email)}&name=${encodeURIComponent(name)}`,
                { method: "DELETE" }
            );

            if (!res.ok) {
                console.log('Did not delete');
                return;
            }

            const data = await res.json();
            console.log("Deleted:", data);

            // Update UI after delete
            setJuugs(prev => prev.filter(j => j.name !== name));
            setJuugToDelete(null);

        } catch (err) {
            console.error(err);
        }
    }

    return (
        <main className="page">
          <div className="page-content">
            <BackButton fallback="/link" />
            <div className="card">
              <h1>Your Juugs</h1>
              <p>Enter the email you used to upload, and we'll show your download links.</p>
              <form onSubmit={e => e.preventDefault()}>
                <div className="field">
                  <label className="label" htmlFor={emailInputId}>Upload email</label>
                  <input
                    id={emailInputId}
                    className="input"
                    type="email"
                    autoComplete="email"
                    inputMode="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </form>
            </div>

            <section aria-label="Your juugs">
              {!hasSearched ? null : juugs.length === 0 ? (
                <p className="empty-state">No juugs found for that email yet.</p>
              ) : (
                <ul className="list">
                  {juugs.map((item) => (
                    <li key={item.name} className="list-item card">
                      <p><strong>Name:</strong> {item.name}</p>
                      <p><strong>Song:</strong> {item.song}</p>

                      {juugToDelete === item.name ? (
                        <div role="group" aria-label={`Confirm delete ${item.name}`}>
                          <p role="alert">Delete "{item.name}"? This can't be undone.</p>
                          <div className="btn-row">
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => deleteJuugs(item.name)}
                            >
                              Yes, delete
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => setJuugToDelete(null)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setJuugToDelete(item.name)}
                        >
                          Delete "{item.name}"
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </div>
        </main>
    );
}

export default Juugs;
